import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  loaderBlock: {
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    alignContent: "center",
  },
}));

export default useStyles;
